export const getInitialValues = ({ checkIn }) => {
  // Omit location, otherwise API crash
  const { location, ...checkInLocation } = getFormattedLocation(checkIn);

  return {
    location: {
      // Flat location
      ...checkInLocation,
      location_type: 'current', // Value need by API
      content_html: checkIn.content_html || '',
    },
  };
};

const getFormattedLocation = (locationValues) =>
  locationDataStructure.reduce((result, attribute) => {
    result[attribute] = locationValues?.[attribute] || '';

    return result;
  }, {});
const locationDataStructure = [
  'address',
  'administrative_area_level_1',
  'administrative_area_level_2',
  'city',
  'colloquial_area',
  'country',
  'country_code',
  'lat',
  'lng',
  'location',
  'neighborhood',
  'postal_code',
  'sublocality_level_1',
];
